/**
 * A single floating number (damage / gold) that drifts upward and fades out.
 * Position + opacity are computed from elapsed time — driven by the rAF loop.
 */
export function FloatingText({ text, x, y, startTime, duration, color }) {
  const elapsed  = performance.now() - startTime;
  const progress = Math.min(1, elapsed / duration);
  const opacity  = 1 - progress;
  const yOffset  = progress * 55;

  return (
    <div
      className="floating-text"
      style={{ transform: `translate3d(${x}px,${y - yOffset}px,0)`, opacity, color }}
    >
      {text}
    </div>
  );
}
